import React from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

const ContentWithTooltip = ({
  cid,
  type,
  content,
}) => {
  function renderTooltip(tooltipType, content) {
    return (
      <Tooltip id={`tooltip-${tooltipType}-${cid}`}>
        {
          content
        }
      </Tooltip>
    );
  }

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip(type, content)}
    >
      <span>{content}</span>
    </OverlayTrigger>
  )
}

export default ContentWithTooltip
